<template>
    <div class="meet-some-members">

        <div class="container-fluid p-0">

            <h2 class="title">Meet Some Members</h2>

            <div class="meet-members-content">
                <div  class="slider-content" id="meet-some-member-slider">
                    <div class="card-slider" v-for="member in members">
                        <div class="card">
                            <div class="card-header" :style="{backgroundImage: `url('${member.cover}')`}"></div>
                            <div class="card-body">
                                <div class="profile">
                                    <img :src="member.avatar" :alt="member.name">
                                    <div class="info">
                                        <h3 v-text="member.name"></h3>
                                        <svg class="verified" v-if="member.verified">
                                            <use xlink:href="#check-star"></use>
                                        </svg>
                                    </div>
                                    <a :href="member.recently_loved.url">
                                        Recently Loved: <span v-text="member.recently_loved.name"></span>
                                    </a>
                                </div>
                                <div class="bio">
                                    <p v-text="member.bio"></p>

                                    <div class="social-medias">
                                        <a v-for="social_media in member.social_medias"
                                           class="badge"
                                           target="_blank"
                                           :href="social_media.url" >

                                            <svg><use :xlink:href="`#${social_media.name}`"></use></svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- Icons for Style -->
        <svg class="user-icon"><use xlink:href="#user-icon"></use></svg>
        <svg class="map-icon"><use xlink:href="#map-icon"></use></svg>
    </div>
</template>
<script>

require('slick-carousel')

export default {

    data() {
        return {
            members: [],
        }
    },

    created() {
        this.members = _.shuffle([
            // Cesar Torres
            {
                name: 'Cesar Torres',
                avatar: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/3874/conversions/uploaded_file-jpg-avatar.jpg',
                cover: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/3875/conversions/amalfi-jpg-cover_photo-mobile@2x.jpg',
                verified: false,
                social_medias: [
                    {
                        name: 'badge-instagram',
                        url: 'https://www.instagram.com/cesartnd/'
                    },
                ],
                recently_loved: {
                    name: 'La Quinta Resort',
                    url: 'https://www.welltraveledclub.com/palm-springs/la-quinta-resort-and-club',
                },
                bio: 'I am an Art Director for Mattel - I love all things creative so naturally I gravitate towards destinations with rich artistic history.'
            },
            // Line Kouecheu
            {
                name: 'Line Kouecheu',
                avatar: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/43372/conversions/uploaded_file-jpg-avatar.jpg',
                cover: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/65054/conversions/WhatsApp-Image-2022-06-27-at-6.00.55-AM-jpg-cover_photo-mobile@2x.jpg',
                verified: true,
                social_medias: [
                    {
                        name: 'badge-instagram',
                        url: 'https://www.instagram.com/latzoumpette'
                    },
                ],
                recently_loved: {
                    name: 'Monsieur Bleu',
                    url: 'https://www.welltraveledclub.com/paris/monsieur-bleu',
                },
                bio: 'I work in product in tech in the SF Bay Area. I have lived in NYC as well and visit often! I enjoy wine tasting, trying out new restaurants and reading a good book.'
            },
            // Gabriella Trapani
            {
                name: 'Gabriella Trapani',
                avatar: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/13167/conversions/uploaded_file-jpg-avatar.jpg',
                cover: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/2971/conversions/croatia-jpg-cover_photo-mobile@2x.jpg',
                verified: true,
                social_medias: [
                    {
                        name: 'badge-instagram',
                        url: 'https://www.instagram.com/gabitrap'
                    }, {
                        name: 'badge-linkedin',
                        url: 'https://www.linkedin.com/in/gabitrapani'
                    },
                ],
                recently_loved: {
                    name: 'The Girl & The Fig',
                    url: 'https://www.welltraveledclub.com/napa/the-girl-and-the-fig',
                },
                bio: 'Corporate attorney & luxury travel creator based in San Francisco, CA. lover of fine wine, sun-kissed skin and ocean air.'
            },
            // Val Ma
            {
                name: 'Val Ma',
                avatar: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/67843/conversions/uploaded_file-jpg-avatar.jpg',
                cover: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/39991/conversions/FB50326F-8E74-463A-8F29-AED477234F5E-jpg-cover_photo-mobile@2x.jpg',
                verified: true,
                social_medias: [
                    {
                        name: 'badge-instagram',
                        url: 'https://www.instagram.com/valpal.ette/'
                    },
                ],
                recently_loved: {
                    name: 'Wet Stories',
                    url: 'https://www.welltraveledclub.com/santorini/wet-stories',
                },
                bio: 'I live for style/fashion + feel most comfortable in color. My go-to travel spot is the countryside of England, but I also love to see new places, especially spots by the ocean.'
            },
            // Sayrge Braccio
            {
                name: 'Sayrge Braccio',
                avatar: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/3074/conversions/uploaded_file-jpg-avatar.jpg',
                cover: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/3075/conversions/croatia-jpg-cover_photo-mobile@2x.jpg',
                verified: true,
                social_medias: [
                    {
                        name: 'badge-instagram',
                        url: 'https://www.instagram.com/sayrgeb'
                    }, {
                        name: 'badge-linkedin',
                        url: 'https://www.linkedin.com/in/sbraccio'
                    },
                ],
                recently_loved: {
                    name: 'Andaz Tokyo',
                    url: 'https://www.welltraveledclub.com/japan/andaz-tokyo',
                },
                bio: 'Avid traveler that works in entertainment marketing. My last trip was to Japan and I\'m looking forward to exploring South America next!'
            },
            // Bhaji Illuminati
            {
                name: 'Bhaji Illuminati',
                avatar: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/11608/conversions/uploaded_file-jpg-avatar.jpg',
                cover: 'https://welltraveledclub.sfo3.digitaloceanspaces.com/wt/media/11977/conversions/138444149_10218611174730198_528365924802874226_n-jpg-cover_photo-mobile@2x.jpg',
                verified: true,
                social_medias: [
                    {
                        name: 'badge-instagram',
                        url: 'https://www.instagram.com/itsbhaji'
                    }, {
                        name: 'badge-linkedin',
                        url: 'https://www.linkedin.com/in/bhajiilluminati'
                    },
                ],
                recently_loved: {
                    name: 'Forty Four Restaurant',
                    url: 'https://www.welltraveledclub.com/croatia/forty-four-restaurant',
                },
                bio: 'I work in tech marketing. In my spare time, I love traveling, hosting dinner parties, playing board games and reading books.'
            },
        ])
    },

    mounted() {
        this.$nextTick(() => {
            $('#meet-some-member-slider').slick({
                infinite: true,
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                speed: 300,
                autoplay: true,
                responsive: [{
                    breakpoint: 650,
                    settings: {
                        centerMode: true,
                        slidesToShow: 1,
                        arrows: false,
                    }
                }, {
                    breakpoint: 992,
                    settings: {
                        centerMode: true,
                        slidesToShow: 2,
                        arrows: false,
                    }
                }, {
                    breakpoint: 1100,
                    settings: {
                        arrows: false,
                    }
                }],
                prevArrow: '<span class="slick-arrow slick-prev"><svg><use xlink:href="#arrow"></use></svg></span>',
                nextArrow: '<span class="slick-arrow slick-next"><svg><use xlink:href="#arrow"></use></svg></span>',
            })
        })
    }
}
</script>
